module.exports = __webpack_public_path__ + "img/business-1.c7efeb1d.png";